// Stable string identity for a grid row, used to match the trend
// tool's `activeRowKey` against a right-clicked row in the grid (so
// Pattern B's "Add to current trend" menu item only appears for the
// row the trend is already showing).
//
// Prefers `groupEntityId` (numeric -- robust to renames + collisions),
// falls back to `name`. Returns null for level scope (no row).

export function activeRowKeyForScope (scope, row) {
  if (scope !== 'row' || !row) return null
  if (row.groupEntityId != null) return `id:${row.groupEntityId}`
  if (row.name != null) return `name:${row.name}`
  return null
}

// Convenience for the grid: row context payload comes from
// react-table's `row.original` (which is the underlying portfolio
// row), with the same shape buildRowRequest expects.
export function activeRowKeyForRow (rowOriginal) {
  return activeRowKeyForScope('row', rowOriginal)
}
